import { HttpClient } from 'base-app'
import { API_GET_ROLES } from '../configs'
class UserGroupService {
  static getRoles() {
    // console.log(HttpClient.get(API_GET_ROLES))
    return HttpClient.get(API_GET_ROLES)
  }
}

export default UserGroupService
